var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.19762 12.8025C1.48129 12.1106 0.909927 11.2831 0.51686 10.368C0.123792 9.453 -0.0831042 8.46885 -0.0917578 7.47301C-0.100411 6.47716 0.0893513 5.48957 0.466458 4.56784C0.843565 3.64612 1.40046 2.80873 2.10466 2.10454C2.80885 1.40034 3.64624 0.843442 4.56797 0.466336C5.48969 0.0892292 6.47728 -0.100534 7.47313 -0.0918799C8.46897 -0.0832263 9.45312 0.12367 10.3682 0.516738C11.2832 0.909805 12.1108 1.48117 12.8026 2.1975C14.1688 3.61201 14.9248 5.50653 14.9077 7.47301C14.8906 9.43948 14.1018 11.3206 12.7113 12.7111C11.3207 14.1017 9.43961 14.8905 7.47313 14.9076C5.50665 14.9246 3.61214 14.1687 2.19762 12.8025ZM3.25512 11.745C4.38096 12.8708 5.90794 13.5033 7.50012 13.5033C9.0923 13.5033 10.6193 12.8708 11.7451 11.745C12.871 10.6192 13.5035 9.09218 13.5035 7.5C13.5035 5.90781 12.871 4.38084 11.7451 3.255C10.6193 2.12915 9.0923 1.49666 7.50012 1.49666C5.90794 1.49666 4.38096 2.12915 3.25512 3.255C2.12928 4.38084 1.49678 5.90781 1.49678 7.5C1.49678 9.09218 2.12928 10.6192 3.25512 11.745ZM10.6801 5.3775L8.55762 7.5L10.6801 9.6225L9.62262 10.68L7.50012 8.5575L5.37762 10.68L4.32012 9.6225L6.44262 7.5L4.32012 5.3775L5.37762 4.32L7.50012 6.4425L9.62262 4.32L10.6801 5.3775Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_211"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButton);
export default __webpack_public_path__ + "static/media/close_button.d4d1f45227328b3d1b05442404db8e87.svg";
export { ForwardRef as ReactComponent };